(function() {
  'use strict';

  function getORPIndex(word) {
    var len = word.length;
    if (len <= 1) return 0;
    if (len <= 5) return Math.floor(len / 2) - 1;
    if (len <= 9) return 2;
    if (len <= 13) return 3;
    return 4;
  }

  function splitWord(word) {
    if (!word || word.length === 0) return { before: '', orp: '', after: '' };
    var stripped = word.replace(/[^a-zA-Z0-9'\u2019-]/g, '');
    if (!stripped.length) return { before: word, orp: '', after: '' };
    var orpInStripped = getORPIndex(stripped);
    var alphaCount = 0;
    var realIndex = 0;
    for (var j = 0; j < word.length; j++) {
      if (/[a-zA-Z0-9'\u2019-]/.test(word[j])) {
        if (alphaCount === orpInStripped) { realIndex = j; break; }
        alphaCount++;
      }
    }
    return {
      before: word.substring(0, realIndex),
      orp: word.charAt(realIndex),
      after: word.substring(realIndex + 1)
    };
  }

  function getDelay(word, wpm) {
    var base = 60000 / wpm;
    if (/[.!?]$/.test(word)) return base * 2.0;
    if (/[,;:\u2014]$/.test(word)) return base * 1.5;
    if (word.length > 8) return base * 1.2;
    return base;
  }

  function init() {
    var hero = document.getElementById('rsvp-hero');
    if (!hero) return;

    var beforeEl = document.getElementById('rsvp-before');
    var orpEl = document.getElementById('rsvp-orp');
    var afterEl = document.getElementById('rsvp-after');
    var slider = document.getElementById('rsvp-slider');
    var wpmLabel = document.getElementById('rsvp-wpm-value');

    var text = hero.getAttribute('data-text');
    if (!text) return;

    var words = text.split(/\s+/).filter(function(w) { return w.length > 0; });
    if (words.length === 0) return;

    var index = 0;
    var running = true;
    var timeoutId = null;
    var manualWPM = null;

    /* ---- Two-phase linear ramp ---- */
    /* Phase 1: 75 → 200 over 8s | Phase 2: 200 → 900 over 52s */
    var rampStart = performance.now();
    var lastDisplayedWPM = 75;
    var PHASE1_END = 8000;
    var PHASE2_END = 60000;

    function getRampWPM() {
      var elapsed = performance.now() - rampStart;
      if (elapsed >= PHASE2_END) return 900;
      if (elapsed <= PHASE1_END) {
        return 75 + (200 - 75) * (elapsed / PHASE1_END);
      }
      var t2 = (elapsed - PHASE1_END) / (PHASE2_END - PHASE1_END);
      return 200 + (900 - 200) * t2;
    }

    function getWPM() {
      if (manualWPM !== null) return manualWPM;
      return getRampWPM();
    }

    /* ---- Smooth slider animation via rAF ---- */
    var sliderAnimId = null;

    function animateSlider() {
      if (manualWPM !== null) {
        sliderAnimId = requestAnimationFrame(animateSlider);
        return;
      }
      var currentWPM = Math.round(getRampWPM());
      if (currentWPM !== lastDisplayedWPM) {
        lastDisplayedWPM = currentWPM;
        slider.value = currentWPM;
        wpmLabel.textContent = currentWPM;
      }
      sliderAnimId = requestAnimationFrame(animateSlider);
    }

    /* ---- Word display loop ---- */
    function display(word) {
      var parts = splitWord(word);
      beforeEl.textContent = parts.before;
      orpEl.textContent = parts.orp;
      afterEl.textContent = parts.after;
    }

    function next() {
      if (!running) return;

      if (index >= words.length) {
        index = 0;
        manualWPM = null;
        rampStart = performance.now();
        lastDisplayedWPM = 75;
      }

      var word = words[index];
      display(word);

      var currentWPM = getWPM();
      var delay = getDelay(word, currentWPM);

      index++;
      timeoutId = setTimeout(next, delay);
    }

    /* ---- Slider drag handling ---- */
    slider.addEventListener('input', function() {
      manualWPM = parseInt(this.value, 10);
      wpmLabel.textContent = manualWPM;
      lastDisplayedWPM = manualWPM;
    });

    slider.addEventListener('change', function() {
      manualWPM = parseInt(this.value, 10);
      wpmLabel.textContent = manualWPM;
      lastDisplayedWPM = manualWPM;
    });

    /* ---- Start everything ---- */
    next();
    animateSlider();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
